import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRemove(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm2 0c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8-8 3.58-8 8Zm4-1a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
